<template>
  <div>
    <div class="hide-on-print">
      <!-- Page Title -->
      <page-title
        icon="fa fa-file-alt"
        main="Relatórios"
        sub="Distribuição de Metas"
      >
      </page-title>

      <!-- Filters -->
      <card>
        <div slot="header" class="row align-items-center">
          <div class="col">
            <h5 class="h3 mb-0">Filtros</h5>
            <h6 class="text-uppercase text-muted ls-1 mb-1">
              Configure quais dados deverão ser listados:
            </h6>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-sm-12">
            <anosafra-multiselect
              v-model="filter.anoSafra"
              label="Ano Safra"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <base-input
              class="mb-3"
              v-model="filter.code"
              placeholder="Ex: 0000083"
              label="Código"
            >
            </base-input>
          </div>
          <div class="col-md-4 col-sm-12">
            <base-input
              class="mb-3"
              v-model="filter.name"
              placeholder="Ex: BELT"
              label="Nome"
            >
            </base-input>
          </div>
          <div class="col-md-4 col-sm-12">
            <brand-multiselect
              ref="brandMultiselect"
              :value="filter.brand"
              @input="filter.brand = $event"
              label="Marca" 
              :multiple="true" 
              :closeOnSelect="false" 
              :api-version="'v1'" 
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Grupo</label>
            <multiselect
              v-model="filter.grupo"
              :options="grupos"
              placeholder="Selecionar Grupo"
              label="descricao"
              track-by="id"
            />
          </div>
          <div class="col-md-4 col-sm-12">
            <label class="form-control-label">Subgrupo</label>
            <multiselect
              v-model="filter.subgrupo"
              :options="subgrupos"
              placeholder="Selecionar Subgrupo"
              label="descricao"
              track-by="id"
            />
            </div>
              <base-input wrapper-class="form-group mb-4 mt-1" class="col-12 col-md-4 mt-2">
              <base-switch
                v-model="analytical"
                left-label="Sintético"
                label="Analítico"
                type="both-side"
                :is-both="true"
              />
              </base-input>
          </div>

        <modal size="lg" :show.sync="modals.modal1">
          <h2 class="modal1">Vendedores</h2>
          <el-table
            :data="salesmen"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column label="Nome" prop="name" min-width="300px" />
            <el-table-column label="Volume" prop="volume" v-slot="{ row }" >
              {{ Math.round(row.volume) || 0 | number }}
            </el-table-column>
            <el-table-column
              label="Volume Estratégico"
              prop="volume_estrategico"
              min-width="200px"
              v-slot="{ row }"
            >
              {{ Math.round(row.volume_estrategico) || 0 | number }}
            </el-table-column>
          </el-table>
          <template slot="footer">
            <base-button type="secondary" @click="modals.modal1 = false"
              >Fechar</base-button
            >
          </template>
        </modal>

        <div slot="footer" class="row justify-content-end mr-1">
          <base-button type="secondary" class="mr-2 mt-2" @click="clearFilters">Limpar Filtros</base-button>
          <base-button type="secondary" class="mr-2 mt-2" v-loading="isLoadingPdf" @click="generateReportFile('pdf')">Gerar PDF</base-button>
          <base-button type="secondary" class="mt-2" v-loading="isLoadingExcel" @click="generateReportFile('xlsx')">Gerar Excel</base-button>
          <base-button
            type="primary"
            class="ml-2 mt-2"
            @click="generateReport"
            v-loading="isLoading"
            >Gerar Relatório</base-button
          >
        </div>
      </card>
    </div>

    <card
      v-show="Object.keys(brands).length"
      ref="report"
      v-loading="isLoading"
    >
      <div class="col hide-on-print">
        <h5 class="h3 mb-0">Relatório</h5>
        <h6 class="text-uppercase text-muted ls-1 mb-1">
          Distribuição de Metas - {{ lastEdition | formatDate("full") }}
        </h6>
      </div>

      <div class="col print-only">
        <img
          :src="
            setting_image && setting_image.logo_sgv && setting_image.logo_sgv.value ?
            setting_image.logo_sgv.value : '/img/brand/top-logo.png'
          "
          class="navbar-brand-img"
          style="
            width: 200px;
            display: block;
            margin-left: auto;
            margin-right: auto;
          "
        />
        <h5 class="h1 mb-0">Relatório</h5>
        <h6 class="h3 text-uppercase text-muted ls-1 mb-1">
          Produtos Preferenciais - {{ lastEdition | formatDate("full") }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.anoSafra && Object.keys(filter.anoSafra).length"
        >
          Subgrupo: {{ filter.anoSafra.descricao }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.code">
          code: {{ filter.code }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.name">
          name: {{ filter.name }}
        </h6>
        <h6 class="text-uppercase text-muted ls-1 mb-1" v-if="filter.brand">
          brand: {{ filter.brand }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.grupo && Object.keys(filter.grupo).length"
        >
          Grupo: {{ filter.grupo.descricao }}
        </h6>
        <h6
          class="text-uppercase text-muted ls-1 mb-1"
          v-if="filter.subgrupo && Object.keys(filter.subgrupo).length"
        >
          Subgrupo: {{ filter.subgrupo.descricao }}
        </h6>
        <br />
        <br />
        <br />
      </div>

      <div v-for="(goals, brand) in brands" :key="brand.id">
        <h5 class="h3 mb-0">Marca - {{ brand }}</h5>
        <br />
        <card id="tableId">
          <el-table
            v-if="goals.length > 0"
            :data="goals"
            class="table-responsive table-striped"
            header-row-class-name="thead-light"
          >
            <el-table-column
              label="Nome"
              width="220px"
              prop="name"
            />
            <el-table-column
              width="160px"
              label="Volume Distribuído"
              min-width="120px"
              style="text-align: center"
              prop="volume"
              v-slot="{ row }"
            >
              <div class="cell" style="text-align: center;">
                {{ Math.round(row.volume) || 0 | number }}
              </div>
            </el-table-column>
            <el-table-column
              width="250px"
              label="Volume Estrategico Distribuído"
              min-width="130px"
              style="text-align: center;"
              prop="volume_estrategico"
              v-slot="{ row }"
            >
              <div class="cell" style="text-align: center;">
                {{ Math.round(row.volume_estrategico) || 0 | number }}
              </div>
            </el-table-column>
            <el-table-column
              width="120px"
              label="Valor Meta"
              min-width="120px"
              prop="valor_meta"
              v-slot="{ row }"
              sortable
            >
            <div style="text-align: center;">
              {{
                row.valor_meta.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </div>
            </el-table-column>
            <el-table-column
              width="170px"
              label="Valor Estrategico"
              min-width="120px"
              prop="valor_estrategico"
              style="text-align: center;"
              v-slot="{ row }"
              sortable
            >
            <div style="text-align: center;">
              {{
                row.valor_estrategico.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "brl",
                })
              }}
            </div>
            </el-table-column>
            <el-table-column label="Ações" prop="acoes" v-slot="{ row }">
              <el-dropdown
                trigger="hover"
                class="dropdown"
                style="cursor: pointer"
              >
                <span class="btn btn-sm btn-icon-only text-success">
                  <i class="fas fa-ellipsis-v mt-2"></i>
                </span>
                <el-dropdown-menu
                  class="dropdown-menu dropdown-menu-arrow show"
                  slot="dropdown"
                >
                  <a
                    class="dropdown-item"
                    href="#"
                    @click="visualize(row.volume_by_salesman)"
                    >Vendedores</a
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-table-column>
          </el-table>
        </card>
        <br />
        <br />
        <br />
      </div>
    </card>
  </div>
</template>

<script>
import PageTitle from "@/layouts/PageTitle";
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";
import BrandMultiselect from '@/components/Multiselect/brand_multiselect.vue';
import AnosafraMultiselect from "@/components/Multiselect/anosafra_multiselect.vue";

import {
  Table,
  TableColumn,
  Dropdown,
  DropdownMenu,
  DropdownItem,
} from "element-ui";

export default {
  components: {
    PageTitle,
    Multiselect,
    BrandMultiselect,
    AnosafraMultiselect,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [TableColumn.name]: TableColumn,
    [Table.name]: Table,
  },
  data() {
    return {
      analytical: false,
      filter: {
        grupo: {},
        subgrupo: {},
        anoSafra: {},
        brand: []
      },
      modals: {
        modal0: false,
        modal1: false,
      },
      brands: {},
      anoSafras: [],
      grupos: [],
      subgrupos: [],
      goals: [],
      salesmen: [],
      lastEdition: new Date(),
      isLoading: false,
      isLoadingExcel: false,
      isLoadingPdf: false
    };
  },
  methods: {
    exportToExcel() {
      return this.$exportToExcel();
    },
    limitText(count) { 
      return `+ ${count}`;
    },
    clearFilters() {
      this.filter.code = "",
      this.filter.name = "",
      this.filter.brand = [];
      this.filter.grupo = {},
      this.filter.subgrupo = {}

      this.$nextTick(() => {
        this.$refs.brandMultiselect.clear();
      });
    },
    async reportRequest(format = null) {
      let requestUrl = `/api/v1/report/goals_by_brands`
      if (format) requestUrl += `.${format}`;

      const requestConfig = { params: {} };
      if (format) requestConfig.responseType = 'arraybuffer';

      try {
        let queryData = {}

        if (this.filter.anoSafra && this.filter.anoSafra.id) {
          queryData.anosafra_id = this.filter.anoSafra.id
        }

        if (this.filter.grupo && this.filter.grupo.id) {
          queryData.grupo_id = this.filter.grupo.id
        }

        if (this.filter.subgrupo && this.filter.subgrupo.id) {
          queryData.subgrupo_id = this.filter.subgrupo.id
        }

        if (this.filter.code) {
          queryData["products[code]"] = this.filter.code
        }

        if (this.filter.name) {
          queryData.name = this.filter.name
        }

        if (this.$refs.brandMultiselect.allSelectedActive && !this.$refs.brandMultiselect.deselectedFromAll.length) {
          queryData.brand_id = 'all';
        } else if (this.$refs.brandMultiselect.deselectedFromAll.length) {
          queryData.brand_id_except = this.$refs.brandMultiselect.deselectedFromAll.map(b => b.id)
        } else if (this.filter.brand && this.filter.brand.length > 0){
          queryData.brand_id = this.filter.brand.map(b => b.id);
        }

        requestConfig.params = { 
          service_params: { analytical: this.analytical, ...queryData},
          reportColumns: this.reportColumns
        }

        const response = await this.$http.secured.get(requestUrl, requestConfig)

        return response
      } catch (error) {
        console.warn("[generateReport] error on get goals_by_brands report data", error);
      }
    },
    async generateReportFile(format) {
      try {
        if (format === 'pdf') {
          this.isLoadingPdf = true;
        } else if (format === 'xlsx') {
          this.isLoadingExcel = true;
        }

        const permittedFormats = ['pdf', 'xlsx'];
        if (!permittedFormats.includes(format)) return;

        const response = await this.reportRequest(format);
        const url      = window.URL.createObjectURL(new Blob([response.data]));
        const link     = document.createElement("a");
        link.href = url;
        link.target = "_blank";
        link.setAttribute(
          "download",
          `relatorio_distribuicao_meta.${format}`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch (error) {
        console.error('[GoalsByBrands][generateReportFile]', error);
      } finally {
        if (format === 'pdf') {
          this.isLoadingPdf = false;
        } else if (format === 'xlsx') {
          this.isLoadingExcel = false;
        }
      }
    },
    async generateReport() {
      this.isLoading   = true;
      const response   = await this.reportRequest();
      this.lastEdition = new Date();
      this.brands      = response.data;
      this.isLoading   = false;
    },
    initGrupos() {
      this.$http.secured
        .get("/api/v1/grupos")
        .then((response) => (this.grupos = response.data));
    },
    visualize(salesmen) {
      this.salesmen = salesmen || [];
      this.modals.modal1 = true;
    },
    initSubgrupos() {
      this.$http.secured
        .get("/api/v1/subgrupos")
        .then((response) => (this.subgrupos = response.data));
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "TOTAL";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = Math.round(sums[index]).toLocaleString('pt-BR');
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
  },
  computed: {
    setting_image() {
      return this.$store.state.imageSettings || {}
    },
    reportColumns() {
      return this.analytical ? this.reportColumnsAnalytical : this.reportColumnsSynthetic;
    }
  },
  mounted() {
    this.currentUser = this.$currentUser();
    this.initGrupos();
    this.initSubgrupos();
  },
};
</script>
<style>
.el-table__fixed,
.el-table__fixed-right {
  background-color: white;
  text-align: center;
}
.modal1 {
  text-align: center;
  margin-bottom: 30px;
}
</style>